"use client";
import React, { useState } from "react";
import { useLocale, useTranslations } from "use-intl";
import { SlidersHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { BrandModel } from "@/types/brand";
import ClientLink from "../ui/client-link";
import { Separator } from "../ui/separator";
import PriceRange from "../product/price-range";
import { CategoryModel } from "@/types/category";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import BrandSidebarContent from "./brand-sidebar-content";

const BrandsFiltersDrawer = ({
  brands,
  categories,
}: {
  brands: BrandModel[];
  categories: CategoryModel[];
}) => {
  const [open, setOpen] = useState(false);
  const t = useTranslations();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger>
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={() => setOpen(true)}
        >
          <SlidersHorizontal className="size-5" />
          {t("brands")}
        </Button>
      </SheetTrigger>
      <SheetContent className="p-4 bg-white space-y-4 max-h-screen overflow-y-auto">
        <BrandSidebarContent
          brands={brands}
          categories={categories}
          setOpen={setOpen}
        />
        <Separator />
        <div>
          <h2 className="font-bold mb-4 text-md">{t("priceRange")}</h2>
          <PriceRange />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default BrandsFiltersDrawer;
